import axios from 'axios';

async function postGoogleSheets(formValues) {
  const response = await axios.get(
    `https://servicetitan-cors.herokuapp.com/https://script.google.com/macros/s/AKfycbyhXuy6fretHC232QMPzhrq-_jd7jBBzxHx2eZgxtyHAoGfHVdj/exec?firstname=${formValues.firstName}&lastname=${formValues.lastName}&email=${formValues.email}&phone=${formValues.phone}&state=${formValues.state}&type=${formValues.type}&description=${formValues.comment}`,
  );

  return response;
}

export default postGoogleSheets;
